import React from 'react';
import { Box, Button, ButtonProps, useMediaQuery, useTheme } from '@material-ui/core';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useTranslation } from 'react-i18next';
import { useWarehouseCardAction } from '../../providers/WarehouseCardActionProvider';
import { Method, routePaths } from '../../../../routePaths';
import { PageWrapper } from '../../../../ui-kit';
import { FixedButtonWrapper } from '../style';

interface WarehousePageWrapperProps {
    buttonRoute?: string;
    isRouteExplicit?: boolean;
    isCrudButtonShown?: boolean;
    onClick?: () => void;
    children: React.ReactNode;
    buttonText?: string;
}

const NavigationButton = ({ onClick, ...other }: ButtonProps | ButtonProps<RouterLink>) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    if (onClick) {
        const buttonProps: ButtonProps = { ...other as ButtonProps, onClick: onClick as ButtonProps['onClick'] };
        return <Button fullWidth={!isDesktop} {...buttonProps} />;
    }

    return <LinkButton fullWidth={!isDesktop} {...other as ButtonProps<RouterLink>} />;
};

const LinkButton = (props: ButtonProps<RouterLink>) => <Button component={RouterLink} {...props} />;

const WarehouseCardsPageWrapper = ({ children }: WarehousePageWrapperProps) => {
    const { currentAction, selectedCardIds } = useWarehouseCardAction();
    const theme = useTheme();
    const { t } = useTranslation();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    const location = useLocation();

    const buttonProps: ButtonProps = {
        startIcon: <AddCircleIcon />,
        variant: 'contained',
        color: currentAction ? 'secondary' : 'primary',
        disabled: currentAction && selectedCardIds.length === 0,
    };

    const buttonText = currentAction
        ? t('Write-off {{numberOfCards}} cards', { numberOfCards: selectedCardIds.length })
        : t('Add new card');

    const pathName = currentAction
        ? `${routePaths.warehouseCards}/write-off`
        : `${routePaths.warehouseCards}${Method.CREATE}`;

    const anchorProps = {
        ...buttonProps,
        to: {
            pathname: pathName,
            state: { background: location }
        },
    };

    const finalProps = anchorProps;

    return (
        <PageWrapper noPadding>
            {isDesktop && (
                <Box width="100%" m={3} display="flex" justifyContent="flex-end">
                    <NavigationButton {...finalProps}>
                        {buttonText}
                    </NavigationButton>
                </Box>
            )}
            {children}
            {!isDesktop && (
            <FixedButtonWrapper>
                <NavigationButton {...finalProps}>
                    {buttonText}
                </NavigationButton>
            </FixedButtonWrapper>
          )}
        </PageWrapper>
    );
};

export default WarehouseCardsPageWrapper;
